import React from "react";

interface WidgetPreviewProps {
  type: "booking" | "form" | "reviews";
  slug?: string;
  color: string; // hex without #
  firmSlug: string;
}

const WidgetPreview: React.FC<WidgetPreviewProps> = ({
  type,
  slug,
  color,
  firmSlug,
}) => {
  const baseUrl = window.location.origin;
  let path: string;

  if (type === "reviews") {
    path = `/embed/reviews/${encodeURIComponent(firmSlug)}`;
  } else {
    path = `/embed/${encodeURIComponent(type)}/${encodeURIComponent(firmSlug)}/${encodeURIComponent(slug || "")}`;
  }

  const url = `${baseUrl}${path}${color ? `?color=${encodeURIComponent(color)}` : ""}`;

  return (
    <div>
      <h4 className="text-sm font-medium text-slate-700 mb-3">Live Preview</h4>
      <div className="border border-slate-200 rounded-xl overflow-hidden bg-slate-50">
        <iframe
          src={url}
          title={`${type} widget preview`}
          className="w-full border-0"
          style={{ height: 420 }}
          sandbox="allow-scripts allow-same-origin allow-forms"
        />
      </div>
    </div>
  );
};

export default WidgetPreview;
